// deps
import styled from "styled-components";

// components
import { default as ArrowIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/arrowFront/16";

export const DownArrowIcon = styled(ArrowIcon)`
    fill: ${props => props.theme.colors.light.background_Add_Button};
    transform: rotate(90deg);
`;
